import styled from 'styled-components';
import { VideoData } from 'types';

import { colors } from 'theme';

export const VideoPlayerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VideoPlayerIframe = styled.iframe<{
  $videoDataType: VideoData['type'];
}>`
  background: ${(props) =>
    props.$videoDataType === 'youtube' ? colors.black : colors.battleshipGrey};
  border: 0;
  aspect-ratio: 16 / 9;
  width: 100%;
  height: 100%;
`;
